import {UseCase} from '@s-ui/domain'

export class GetEventTrackingDataUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Function} deps.trackingDataService
   */
  constructor({config, trackingDataService}) {
    super({config, trackingDataService})

    this._trackingDataService = trackingDataService
  }

  /**
   * @param {Object} params
   * @param {String} params.event
   * @param {String} params.origin
   * @param {String} params.context
   
   * @return {Promise<Object, Error>} This is a Promise return value.
   */
  execute(params) {
    return this._trackingDataService.execute(params)
  }
}
